import { useQuery } from "@tanstack/react-query";
import { getApiUsersUserID } from "Infrastructure/Api/Api";

export const USER_DETAIL_QUERY_KEY = "USER_DETAIL_QUERY";

export function useUserDetailQuery(id: number) {
  const query = useQuery({
    queryKey: [USER_DETAIL_QUERY_KEY, id],
    queryFn: () => getApiUsersUserID(id),
  });

  return query;
}
